/* eslint-disable no-param-reassign */
import Vapi from 'vuex-rest-api';

const spawnerAdminSchemas = new Vapi({
  state: {
    spawnerAdminSchemas: {
      forms: {},
    },
  },
})
  .get({
    action: 'getSpawnerAdminSchema',
    path: ({
      schema,
    }) => `/api/spawner/admin/schemas/${schema}`,
    onSuccess: (state, payload, axios, { params }) => {
      state.spawnerAdminSchemas[params.schema] = payload.data;
    },
  })
  .getStore();

export default spawnerAdminSchemas;
